module.exports = __webpack_public_path__ + "assets/img/title-20ca7181.png";